import { render } from "./ButtonMenu.vue?vue&type=template&id=5ac0da66&scoped=true"
import script from "./ButtonMenu.vue?vue&type=script&lang=js"
export * from "./ButtonMenu.vue?vue&type=script&lang=js"

import "./ButtonMenu.vue?vue&type=style&index=0&id=5ac0da66&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac0da66"]])

export default __exports__